import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  DxButtonComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxPopupComponent,
} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { Articoli } from 'src/app/models/articoli';

@Component({
  selector: 'app-popup-sostituisci-articolo',
  templateUrl: './popup-sostituisci-articolo.component.html',
  styleUrls: ['./popup-sostituisci-articolo.component.scss'],
  imports: [
    DxPopupComponent,
    DxLoadPanelComponent,
    DxButtonComponent,
    DxLookupComponent,
  ],
  standalone: true,
})
export class PopupSostituisciArticoloComponent implements OnInit {
  @Input() idArticolo: number;
  @Output() popupSostituisciArticoloEventEmitter = new EventEmitter<boolean>();

  loadPanelVisible = false;
  listArticoli: any;

  articolo: Articoli;

  idArticoloSostitutivo: number;
  private articoliService = inject(ArticoliService);

  ngOnInit() {
    this.loadArticolo();
    //this.loadLookups();
  }

  loadArticolo() {
    this.loadPanelVisible = true;
    this.articoliService.get(this.idArticolo).subscribe({
      next: (dati) => {
        this.loadPanelVisible = false;
        this.articolo = dati;
        this.loadArticoliSostitutivi();
      },
      error: (error) => {
        this.loadPanelVisible = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento articolo', 'warning');
        }
      },
    });
  }

  loadArticoliSostitutivi() {
    this.articoliService.listByTipo(this.articolo.idTipo, true).subscribe({
      next: (res) => {
        this.listArticoli = {
          store: {
            type: 'array',
            data: res.filter((a) => a.id != this.articolo.id),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento articoli', 'error', 3000);
        }
      },
    });
  }

  onEsciClick() {
    this.popupSostituisciArticoloEventEmitter.emit(false);
  }

  onSalvaClick() {
    if (this.idArticoloSostitutivo == 0) {
      notify('Selezionare articolo sostitutivo', 'warning');
      return;
    }
    this.loadPanelVisible = true;
    this.articoliService
      .sostituisciArticolo(this.articolo.id, this.idArticoloSostitutivo)
      .subscribe({
        next: () => {
          this.articoliService.list(true).subscribe();
          this.loadPanelVisible = false;
          notify('Articolo sostituito', 'success', 3000);
          this.popupSostituisciArticoloEventEmitter.emit(true);
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore sostituzione articolo', 'error', 3000);
          }
        },
      });
  }

  getArticoloDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }
}
